import React from 'react';
import { CellType } from '../game/Game';

interface CellProps {
  type: CellType;
  size: number;
}

const CELL_COLORS: Record<CellType, string> = {
  ' ': '#f5e6d3',
  '#': '#4a4a4a',
  '@': '#e74c3c',
  '+': '#e74c3c',
  '$': '#d35400',
  '*': '#27ae60',
  '.': '#9b59b6',
};

const CELL_STYLES: Record<CellType, React.CSSProperties> = {
  ' ': { backgroundColor: CELL_COLORS[' '] },
  '#': { 
    backgroundColor: CELL_COLORS['#'],
    borderRadius: '2px',
  },
  '@': { 
    backgroundColor: CELL_COLORS[' '],
    position: 'relative' as const,
  },
  '+': { 
    backgroundColor: CELL_COLORS['.'],
    position: 'relative' as const,
  },
  '$': { 
    backgroundColor: CELL_COLORS[' '],
    position: 'relative' as const,
  },
  '*': { 
    backgroundColor: CELL_COLORS['.'],
    position: 'relative' as const,
  },
  '.': { backgroundColor: CELL_COLORS['.'] },
};

const getWorkerContent = (type: CellType) => {
  if (type === '@' || type === '+') {
    return (
      <div
        style={{
          position: 'absolute',
          top: '10%',
          left: '10%',
          width: '80%',
          height: '80%',
          borderRadius: '50%',
          backgroundColor: '#e74c3c',
          border: '2px solid #c0392b',
        }}
      />
    );
  }
  return null;
};

const getBoxContent = (type: CellType) => {
  if (type === '$') {
    return (
      <div
        style={{
          position: 'absolute',
          top: '10%',
          left: '10%',
          width: '80%',
          height: '80%',
          backgroundColor: '#d35400',
          border: '3px solid #a04000',
          borderRadius: '4px',
        }}
      />
    );
  }
  if (type === '*') {
    return (
      <div
        style={{
          position: 'absolute',
          top: '10%',
          left: '10%',
          width: '80%',
          height: '80%',
          backgroundColor: '#27ae60',
          border: '3px solid #1e8449',
          borderRadius: '4px',
        }}
      />
    );
  }
  return null;
};

const getDockContent = (type: CellType) => {
  if (type === '.') {
    return (
      <div
        style={{
          position: 'absolute',
          top: '25%',
          left: '25%',
          width: '50%',
          height: '50%',
          borderRadius: '50%',
          border: '3px solid #8e44ad',
          backgroundColor: 'transparent',
        }}
      />
    );
  }
  return null;
};

export const Cell: React.FC<CellProps> = ({ type, size }) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        boxSizing: 'border-box',
        border: '1px solid #ccc',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        ...CELL_STYLES[type],
      }}
    >
      {getDockContent(type)}
      {getBoxContent(type)}
      {getWorkerContent(type)}
    </div>
  );
};